import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import bottle from './bottle';

import { providers } from '../../store/users/usersReducers';

const mapStateToProps = (state = { users: {} }) => ({ ...state.users, ...state.modelPages });
const mapDispatchToProps = dispatch => Object.keys(providers)
  .reduce((dispatcher, name) => ({
    ...dispatcher,
    [name]: (...args) => dispatch(providers[name](...args)),
  }), {});
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(bottle().container.MainContainer));

